import React from 'react';
import { RUNE_DATA, ARCANE_RUNE_COLOR } from '../../themes/runes';

export const CampaignRune = ({ name, size = 56, color = ARCANE_RUNE_COLOR, glow = 0, shadow = 0, style = {} }) => {
  const src = RUNE_DATA[name] || RUNE_DATA.tech;
  const filters = [];
  if (glow > 0) {
    filters.push(`drop-shadow(0 0 ${4 * glow}px ${color})`);
    filters.push(`drop-shadow(0 0 ${10 * glow}px ${color})`);
  }
  if (shadow > 0) {
    // Drop shadow scales with size: tighter inner + softer outer, both dark.
    // Stacked beneath the glow filters in the chain so it reads behind the rune.
    filters.push(`drop-shadow(0 ${size * 0.04 * shadow}px ${size * 0.08 * shadow}px rgba(0,0,0,0.7))`);
    filters.push(`drop-shadow(0 0 ${size * 0.18 * shadow}px rgba(0,0,0,0.55))`);
  }
  const filterValue = filters.length > 0 ? filters.join(' ') : 'none';
  return (
    <div style={{
      width: size, height: size,
      backgroundColor: color,
      maskImage: `url(${src})`,
      WebkitMaskImage: `url(${src})`,
      maskRepeat: 'no-repeat',
      WebkitMaskRepeat: 'no-repeat',
      maskSize: 'contain',
      WebkitMaskSize: 'contain',
      maskPosition: 'center',
      WebkitMaskPosition: 'center',
      filter: filterValue,
      transition: 'filter 220ms ease, background-color 220ms ease',
      ...style,
    }} />
  );
};
